<div class="aig-link">
    <div class="u-text-center u-mb-2">
        <div class="banner u-bg-disabled1 u-radius-1 u-px-4 u-py-2">
            <p class="u-color-primary1 u-fs-28 u-fw-500">{{ tarifas?.primaBrutaAnual?.toLocaleString('es-Es', { minimumFractionDigits: 2 }) }} € al año</p>
            <p class="u-color-primary1 u-fs-16 u-px-9 u-py-3">Por ser empleado de Caixabank, disfruta de 3 meses de seguro gratis el primer año. Por menos de lo que cuesta un café al mes, estarás protegido contra incidentes y fraudes cibernéticos (prima total anual al aplicar la promoción: {{ tarifas?.primaBrutaPromocional?.toLocaleString('es-Es', { minimumFractionDigits: 2 }) }} € impuestos incluidos). Dicho importe se devengará al principio del cuarto mes de seguro de la cuenta bancaria designada a tal efecto. En caso de que ya haya contratado una póliza anteriormente no se le podrá aplicar el descuento.</p>
        </div>
        <div class="p-flexcc">
            <div class="aig-link__arrow u-size-1 u-height-1 u-bg-disabled1"></div>
        </div>
    </div>
    <div class="p-flexcc">
        <a class="e-btn--primary u-size-content" [routerLink]="['/contratacion-poliza']" routerLinkActive="active">Contratar ahora</a>
    </div>
</div>
